export interface IFee {
  value: number;
  text: string;
}

export const HAQQ_FEES: IFee[] = [
  { value: 100, text: '0.01%' },
  { value: 500, text: '0.05%' },
  { value: 3000, text: '0.3%' },
  { value: 10000, text: '1%' },
];

export const UNISWAP_FEES: IFee[] = [
  { value: 100, text: '0.01%' },
  { value: 500, text: '0.05%' },
  { value: 1000, text: '0.1%' },
  { value: 3000, text: '0.3%' },
  { value: 10000, text: '1%' },
];

export const PANCAKE_FEES: IFee[] = [
  { value: 100, text: '0.01%' },
  { value: 500, text: '0.05%' },
  { value: 2500, text: '0.25%' },
  { value: 10000, text: '1%' },
];

export const AERODROM_FEES: IFee[] = [
  { value: 1, text: '1' },
  { value: 10, text: '10' },
  { value: 50, text: '50' },
  { value: 100, text: '100' },
  { value: 200, text: '200' },
  { value: 2000, text: '2000' },
];

// Aerodrome Slipstream V2 (Gauges V3 factory) enabled tickSpacings — on-chain
// verified: [1, 10, 50, 100, 200, 500, 2000]. Distinct from AERODROM_FEES (adds 500).
export const AERODROME_V3_2_FEES: IFee[] = [
  { value: 1, text: '1' },
  { value: 10, text: '10' },
  { value: 50, text: '50' },
  { value: 100, text: '100' },
  { value: 200, text: '200' },
  { value: 500, text: '500' },
  { value: 2000, text: '2000' },
];
